import { render, staticRenderFns } from "./CadCodigoApetrus.vue?vue&type=template&id=0d2d58f2&"
import script from "./CadCodigoApetrus.vue?vue&type=script&lang=js&"
export * from "./CadCodigoApetrus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports